<template>
  <section class="header header-001">
    <page-header-search />
    <div class="secondary-region">
      <b-container>
        <div
          class="navbar navbar-expand-lg"
        >
          <commponent :is="elementLogoComponent" />
          <b-collapse
            id="nav_collapse"
            is-nav
          >
            <user-actions :help-active="helpActive" />
          </b-collapse>
          <component :is="mobilenavcomponent" />
        </div>
      </b-container>
    </div>
    <div class="primary-region">
      <component :is="primaryWrapComponent">
        <b-navbar
          :class="desktopMenuDisplayPort"
          toggleable="md"
        >
          <main-menu menu-style="desktop" />
        </b-navbar>
      </component>
    </div>
  </section>
</template>

<script>
import CommonMixin from '../mixins/page-navbar'

export default {
  name: 'page-navbar-0001',
  asyncComponents: [
    'user-actions'
  ],
  mixins: [
    CommonMixin
  ],
  props: {
    'helpActive': {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data: function() {
    return {
      menuHidden: true,
      mobileMenuDisplayPort: 'd-block d-lg-none',
      desktopMenuDisplayPort: 'd-none d-lg-block'
    }
  },
  computed: {
    primaryWrapComponent() {
      return this.$store.getters['getModuleSetting']('theme', 'primary-region-inner-container', true) ? 'b-container' : 'div'
    },
    mobilenavcomponent() {
      let mobileNavVersion = this.$store.getters['getModuleSetting']('theme', 'mobile-nav', 'mobile-menu')
      return `mobile-nav-${mobileNavVersion}`
    },
  },
  created: function() {
    this.$eventHub.$on('hideMobileMenu', this.hideMobileMenu)
    this.$eventHub.$on('showMobileMenu', this.showMobileMenu)
  },
  methods: {
    hideMobileMenu: function() {
      this.menuHidden = true
    },
    showMobileMenu: function() {
      this.menuHidden = false
    }
  },
}
</script>
<style lang="scss">
@import '~@scss/custom.scss';

    %nav-link {
      font-family: var(--main-heading-font);
      float: none;
      padding: 1.5rem 0.25rem;
      font-size: 1.1em;
      text-align: center;
      color: var(--main-header-primary-region-background-text-color);
      white-space: normal;
      @include hover-focus {
      color: var(--main-header-primary-region-background-highlight-text-color);
      }
    }

    .header {
      &.header-001 {
      position: relative;
      z-index:20;
      .edit-node {
        top: 0;
      }
      ul {
        list-style:none;
        padding: 0;
        margin:0;
      }
      .content-creator-editor-container {
        .container {
          padding:0em;
        }
      }
      .secondary-region {
        background-color: var(--main-header-secondary-region-background);
        padding: .5rem 0rem;
        @include media-breakpoint-up(sm) {
        padding: .75rem 0rem;
        }
        @include media-breakpoint-up(md) {
        padding: 1.5rem 0rem;
        }
        .navbar {
          padding: 0em;
        }
        a {
          color:var(--main-header-secondary-region-text-color);
        }
        .nav-item{
          display:flex;
        }
        .nav-link{
          display:flex;
          align-items: center;
          &.logout,
          &.login,
          &.cart,
          &.portal {
            .icon-container{
              margin-right:.75em;
            }
            .icon {
              fill:var(--main-header-secondary-region-icon-color);
              width:2.25em;
              height:2.25em;
            }

          }
          &.portal {
            .btn-link {
              border:0px;
            }
          }
          &.cart {
            &.has-items {
              padding-right:1em;
            }
          }
          .btn-link{
            @include hover-focus{
              border:none;
              text-decoration: none;
            }
          }
          .nav-link-button-inner {
            display:flex;
            align-items: center;
            .nav-label {
          color:var(--main-header-secondary-region-text-color);

            }
          }
        }
        .dropdown-menu {
          border:0px;
          background-color:var( --main-site-header-dropdown-background-color);

          box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
          &:before {
            width: 1.5em;
            height: .75rem;
            background:var(--main-site-header-dropdown-background-color);
            -webkit-clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
            clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0em;
            z-index: 1;
            transform: translate(0, 0em);
            transition: translate, 0.3s;
            content: " ";
            top: -.7rem;
            right: 1em;
            margin-left: auto;
          }
          .dropdown-item {
            padding: 0.25rem 1rem;
            color:var(--main-site-header-dropdown-link-color);
            @include hover-focus {
            color:var(--main-site-header-dropdown-hover-link-color);
            background-color:var(--main-site-header-dropdown-hover-background-color);
            }
          }
        }
      }

      .primary-region {
        background-color: var(--main-header-primary-region-background);

        .navigation.nav {
          .show {
              .dropdown-toggle::after {
                  opacity:1;
              }
            >.nav-link {
              background-color: var(--main-header-primary-region-background-highlight);
              color:var(--main-header-primary-region-background-highlight-text-color);
            }
          }

          .nav-item {
            .dropdown-menu {
              width:100%;
            }
            &:not(:last-child) {
              border: none !important;
            }

            > a {
              font-family: var(--main-heading-font);
              color: var(--main-header-primary-region-background-text-color);
              transition: ease-in-out all .2s;

              @include hover-focus {
                background-color: var(--main-header-primary-region-background-highlight);

              }

              &.show {
                background-color: var(--main-header-primary-region-background-highlight);
              }

            }

            &.mega-menu {
              .dropdown-menu {
                top: 4.7em;
                flex-wrap: nowrap;

                &.show {
                  display: flex;
                }

                .menu-columns {
                  float: none;
                  width: auto;
                  flex: 1;
                  .nav-item a,
                  a {
                    padding:.75rem 0em;
                    font-size: 1.1em;
                    text-align:left;
                  }
                  h3 {
                    font-size: 1.5em;
                  }

                  .nav-item {
                    &:hover {
                      background: transparent;
                    }

                  }
                }
              }
            }
          }

          ul {
            flex: 1 1 auto;

            .nav-item {
              float: none;

              > .nav-link {
                @extend %nav-link;
              }
            }
          }

          .nav-item {

            .dropdown-menu{
              background-color:var(--main-header-primary-region-dropdown-background);
              box-shadow: var(--main-header-primary-region-dropdown-background-box-shadow);
              a {
              white-space: normal;
              padding: .75rem 1rem;
              font-size:1.1em;
              text-align: left;
              color:var(--main-header-primary-region-dropdown-text-color);
              @include hover-focus{
                background:var(--main-header-primary-region-dropdown-background-highlight-color);
                color:var(--main-header-primary-region-dropdown-text-color);
              }
              }
            }
          }
        }

      }

      >.primary-region {

        //background:orange;
        .navigation {
          display: flex;
          flex-flow: row nowrap;
          width: 100%;

          //list item
          >.nav-item {
            flex: 1 1 auto;

            &:not(:last-child) {
              border-right: 1px solid;
              border-color: $border-color;
            }

            //link
            > .nav-link {
                &.dropdown-toggle::after {
                  margin-left:.5em;
                  opacity:.5;
                  @include transition (opacity .3s);
              }
              @extend %nav-link;

            }
            @include hover-focus {
              .dropdown-toggle::after {
                  opacity:1;
              }
            }
          }
        }

        .navbar {
          padding: 0em;
        }

      }

    }
    }

    .main-wrap {
      &:before {
        background-color: #000000;
        position: fixed;
        content: '';
        opacity: 0;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: -10;
        transition: opacity 300ms ease-out 0ms, z-index 0s linear 300ms;
        -webkit-transition: opacity 300ms ease-out 0ms, z-index 0s linear 300ms;
      }

      &.search-overlay {
        &:before {
          background-color: #000000;
          opacity: 0.3;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 8;
          transition: opacity 300ms ease-in-out;
          -webkit-transition: opacity 300ms ease-in-out;
        }
      }
    }

</style>
